// src/components/theme-toggle.tsx

import { Monitor, Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { useT } from "@/lib/translation";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateUserSettings } from "@/api/client";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";

export function ThemeToggle() {
  const t = useT();
  const { theme, setTheme } = useTheme();
  const queryClient = useQueryClient();
  const { mutate: saveTheme } = useMutation({
    mutationFn: updateUserSettings,
    onSuccess: () =>
      queryClient
        .invalidateQueries({ queryKey: ["userSettings"] })
        .catch(() => {}),
  });

  return (
    <ToggleGroup
      type="single"
      value={theme}
      onValueChange={(v) => {
        if (!v) return;
        setTheme(v);
        saveTheme({ theme: v });
      }}
      className="gap-1 rounded-lg border p-1"
    >
      <ToggleGroupItem value="light" size="sm" className="h-8 w-8 p-0">
        <Sun className="h-4 w-4" />
        <span className="sr-only">{t("nav:themeToggle.light")}</span>
      </ToggleGroupItem>
      <ToggleGroupItem value="dark" size="sm" className="h-8 w-8 p-0">
        <Moon className="h-4 w-4" />
        <span className="sr-only">{t("nav:themeToggle.dark")}</span>
      </ToggleGroupItem>
      <ToggleGroupItem value="system" size="sm" className="h-8 w-8 p-0">
        <Monitor className="h-4 w-4" />
        <span className="sr-only">{t("nav:themeToggle.system")}</span>
      </ToggleGroupItem>
    </ToggleGroup>
  );
}
